/**
 * RTK Query sets `status` back to `pending` when a failed query is refetched,
 * which clears `isError` for the duration of the retry while `data` is still
 * undefined. Rendering straight off `isError` therefore drops back to the empty
 * state mid-retry and only returns to the error state once the retry fails.
 * `error` is left untouched by the pending reducer, so it is what tells us the
 * last settled result was a failure.
 */
export interface QueryResultState {
  isFetching: boolean;
  isError: boolean;
  error?: unknown;
}

export interface ContentState {
  isLoading: boolean;
  isError: boolean;
}

export function getContentState({
  isFetching,
  isError,
  error,
}: QueryResultState): ContentState {
  return {
    isLoading: isFetching,
    isError: isError || (isFetching && error !== undefined),
  };
}
